import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_USER_THREADS = gql`
  query GetUserThreads(
    $identity: CustomerIdentity!
    $pageSize: Int
    $cursor: String
    $sort: String
    $mode: String
  ) {
    getUserThreads(
      identity: $identity
      pageSize: $pageSize
      cursor: $cursor
      sort: $sort
      mode: $mode
    ) {
      threads {
        uuid
        threadUuid
        userUuid
        title
        createdDatetime
        updatedDatetime
      }
      total
      hasNextPage
      nextCursor
    }
  }
`;
